import { useState, useEffect } from 'react';

interface ScreenOrientation {
  isPortrait: boolean;
  isLandscape: boolean;
  aspectRatio: number;
  width: number;
  height: number;
}

export const useScreenOrientation = (): ScreenOrientation => {
  const [orientation, setOrientation] = useState<ScreenOrientation>(() => {
    if (typeof window === 'undefined') {
      // Default for SSR
      return {
        isPortrait: true,
        isLandscape: false,
        aspectRatio: 0.5625, // 9:16
        width: 375,
        height: 667
      };
    }

    const { innerWidth, innerHeight } = window;
    const aspectRatio = innerWidth / innerHeight;
    const isPortrait = innerHeight > innerWidth;

    return {
      isPortrait,
      isLandscape: !isPortrait,
      aspectRatio,
      width: innerWidth,
      height: innerHeight
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth, innerHeight } = window;
      const aspectRatio = innerWidth / innerHeight;
      const isPortrait = innerHeight > innerWidth;

      setOrientation({
        isPortrait,
        isLandscape: !isPortrait,
        aspectRatio,
        width: innerWidth,
        height: innerHeight
      });
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Also listen for orientation change on mobile
    window.addEventListener('orientationchange', () => {
      // Small delay to ensure dimensions are updated after orientation change
      setTimeout(handleResize, 100);
    });

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return orientation;
};